import { type ReactElement } from 'react';
import { Container } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Card, CardContent } from '@/components/ui/card';
import { PageHeader } from '@/components/shell/PageHeader';
import { DockerHubCredentialsForm } from '@/features/platform/components/DockerHubCredentialsForm';

/**
 * Cluster-global DockerHub credentials console tab (PTV2-1383). Previously an icon button in the
 * tenants header opening a modal; now its own tab under the platform Access section, rendering the
 * shared {@link DockerHubCredentialsForm} inline.
 */
export function PlatformDockerHubPage(): ReactElement {
  const { t } = useTranslation();
  return (
    <>
      <PageHeader
        icon={<Container className="h-[18px] w-[18px]" aria-hidden="true" />}
        title={t('routes.platform.dockerhub.heading')}
        subtitle={t('routes.platform.dockerhub.subheading')}
      />
      <div className="space-y-4 bg-background px-8 py-5">
        <Card className="max-w-2xl">
          <CardContent className="pt-6">
            <DockerHubCredentialsForm active />
          </CardContent>
        </Card>
      </div>
    </>
  );
}
